<template>
    <div>
        <el-row class="marB10">
            <el-col :span="8" :style="{height: tableHeight+100+'px',minWidth: '320px'}" class="bor">

                <div class=" searchBox">
                    <el-input v-model="search" size="mini" placeholder="输入关键字进行查找品种"></el-input>
                    <el-button class="marL5 " icon="el-icon-search" circle  @click="searchbtn" size="mini"></el-button>
                </div>
                <div class="con" :style="'height:'+tableHeight+'px'">
                    <el-checkbox-group v-model="chooseList" @input="choosepz">
                        <el-checkbox v-for="(item,index) in gysList" :key="item.i_cid" :label="item"  style="padding: 5px 0;display: block">
                        {{item.vc_cname}}
                       </el-checkbox>
                   </el-checkbox-group>
                </div>
                <el-pagination  style="margin-top: 10px;text-align: right"
                                  background
                                  @current-change="pageCurrentChange"
                                  layout="total,prev, pager, next"
                                  :current-page.sync="currentPage"
                                  :total="total"
                                  :page-size="pageSize">
                </el-pagination>
            </el-col>
            <el-col :span="4"  style="height: 100%;">
                <div :style="{lineHeight:tableHeight+'px',textAlign:'center',overflowY: 'auto'}">
                    <el-button class="bcBtn" @click="addChoose" :class="baseerp+'btn'" size="mini" >添加</el-button>
                    <el-button class="bcBtn" @click="deleteChoose" :class="baseerp+'btn'" size="mini">删除</el-button>
                </div>
            </el-col>
            <el-col :span="12" class="bor"  :style="{height: tableHeight+100+'px',minWidth: '320px',overflowY: 'auto'}">
                <div class="con" >
                    <el-checkbox-group v-model="rightChoose" >
                        <div v-for="(item,i) in rightData" >
                            <el-checkbox  :label="item" :key="item.i_cid">
                                <span>{{item.vc_cname}}</span>
                            </el-checkbox>
                            <el-button style="position: relative" size="mini">上传附件<input type="file" name="files" value="" id="uploadfile" ref="uploadclear1"    class="upload-input uploadfile1" @change="uploadFile($event,i)" ></el-button>
                            <div style="margin-left: 24px" v-for="(file,index) in item.vc_files.otherfiles">
                                <a style="font-size: 14px" :download="file.vc_name" mce_href="#"
                                   :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+file.vc_newname+',tenderapp\'}','utf-8')">
                                    {{file.vc_name}}
                                </a>
                                <el-button size="mini" icon="el-icon-close" type="text" @click="clearFile(file,index,i)" ></el-button>
                            </div>
                        </div>
                    </el-checkbox-group>
                </div>
            </el-col>
        </el-row>
        <div class="center"style="margin-top: 15px;">
            <el-button @click="save" :class="baseerp+'btn'" size="mini">
                {{$t('button_confirm')}}
            </el-button>
            <el-button @click="cancel" size="mini">取 消</el-button>

        </div>


    </div>
</template>

<script>
    import * as API from "../../api"
    import {mapActions} from "vuex";
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "PzList",
        components: {},
        props:{
            gysData:{
                type: Array,
                default:()=>[],
            },
        },
        data() {
            return {
                gysList: [],
                search:'',
                pzid:[],
                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
                pzitem:[],
                currentPage:1,
                pageSize:20,
                total:0,
                tableHeight:0,
                chooseList:[],
                rightData:[],
                rightChoose:[],
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.gykhList()
            this.$nextTick(()=>{
                this.onResize();
                this.rightData=this.gysData
            })
            // this.baseerp=baseerp;
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-25

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            searchbtn(){
                this.currentPage=1
                this.gykhList()
            },
            addChoose(){
                if (this.chooseList.length>=1){
                    this.chooseList.forEach(val=>{
                        let at=this.rightData.find(item=>item.i_cid==val.i_cid);
                        // console.log(at,'at')
                        if(!at){
                            let data=val;
                            data.vc_files={otherfiles:[],signfile:{}}
                            this.rightData.unshift(data)

                        }
                    })
                    this.chooseList=[]
                    this.gysList.map(one=>{
                        this.$set(one,'leftCheck',false)
                        // one.leftCheck=false
                    });
                    this.rightChoose=[]
                    this.rightData.map(one=>{
                        one.rightCheck=false
                    })
                    // this.chooseList=[];
                }
            },
            deleteChoose(){
                if (this.rightChoose.length>=1) {
                    this.rightData=[...this.rightData].filter(x=>[...this.rightChoose].every(y=>y.i_cid!==x.i_cid))
                    this.rightChoose=[]
                    this.rightData.map(one=>{
                        one.rightCheck=false
                    })
                }
            },
            async gykhList(){
                let param={
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_search:this.search,
                };
                let res=await API.gykhList(param);
                if ( res.code == 1 ){
                    this.gysList=res.data.list
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.gykhList();
            },
            choosepz(val){
                this.chooseList=val
            },
            save(){
                this.$emit('close',this.rightData)
            },
            cancel(){
                this.$emit('close')
            },
            async uploadFile(e,index) {
                let that = this;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "tenderapp",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "tenderapp",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("lruname"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        let file={
                            i_id:res.data[0].i_id,
                            vc_name:res.data[0].filename,
                            vc_newname:res.data[0].filenewname,
                            vc_path:res.data[0].vc_path,
                            vc_app:'tenderapp'
                        }
                        this.rightData[index].vc_files.otherfiles.push(file)
                        this.$forceUpdate()

                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            clearFile(val,index,i){
                this.rightData[i].vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },

        },
    }
</script>

<style lang="scss" scoped>
    .searchBox{
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .marL5{
        margin-left: 5px;
    }
    .con{
        /*height: 500px;*/
        overflow-y: auto;
    }
    .bor{
        border: 1px solid #ebeef5;
        padding: 8px 10px;
        border-radius: 5px;
    }
    .center{
        text-align: center;
    }
    .hiscss{
        display: inline-block;
        padding: 3px 5px;
        background-color: #b2b2b2;
        color: white;
        font-size: 12px;
        border-radius: 6px;
        margin: 3px;
    }
    .hisbox{
        min-height: 29px;
        margin-top: 3px;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
</style>